export const pointInPolygon = (p, polygon) => {
    let nvert = polygon.length;
    let vertx = polygon.map((arr) =>  arr[0])
    let verty = polygon.map((arr) =>  arr[1])
    let testx = p[0];
    let testy = p[1];

    return pnpoly(nvert, vertx, verty, testx, testy);
}

/**
 * From: https://wrfranklin.org/Research/Short_Notes/pnpoly.html
 * 
 * @param {*} nvert Number of vertices in the polygon. Whether to repeat the first vertex at the end is discussed below
 * @param {*} vertx @param {*} verty Arrays containing the x- and y-coordinates of the polygon's vertices.
 * @param {*} testx @param {*} testy  X- and y-coordinate of the test point.
 * @returns 
 */
const pnpoly = (nvert, vertx, verty, testx, testy) => {
    let i,
        j,
        c = false;

    for (i = 0, j = nvert - 1; i < nvert; j = i++) {
        if (
            (verty[i] > testy) !== (verty[j] > testy) &&
            testx < ((vertx[j] - vertx[i]) * (testy - verty[i])) / (verty[j] - verty[i]) + vertx[i]
        )
            c = !c;
    }
    return c;
};
